var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V6M12 6L9 8M12 6L15 8M23 11C23 8.79086 21.2091 7 19 7C18.9764 7 18.9532 7.00021 18.9297 7.00062C18.4447 3.60802 15.5267 1 12 1C9.20335 1 6.79019 2.64004 5.66895 5.01082C3.06206 5.18144 1 7.34981 1 9.99985C1 12.7613 3.23858 15.0001 6 15.0001L19 15C21.2091 15 23 13.2091 23 11Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarImages);
export default __webpack_public_path__ + "static/media/sidebar-images.e90bfbc39f2a71ce7c2a657a1820c3ba.svg";
export { ForwardRef as ReactComponent };